module.exports = __webpack_public_path__ + "media/images/hapier/conceito_hapier_4-0ca64b4a6cebf5bc7aa3bfd8a38d6dc7.png";